<div class="divbox" fxLayoutAlign="center center">
  <mat-card class="box">
    <div>

      <div class="divtitle">
        <mat-card-title class="clstitle">{{titleCompany}}</mat-card-title>
      </div>

      <div class="divLogo" *ngIf="hasLogo">
        <img [src]="imgUrl" class="logo">
      </div>

      <div class="divForm">
        <form method="post" class="form" #f="ngForm" (ngSubmit)="f.form.valid && onGuardarItm()">
          <mat-card-content class="mat-elevation-z8">
            <mat-form-field class="full-width">
              <mat-label>{{'company.name' | transloco}}</mat-label>
              <input matInput type="text" name="name" placeholder="{{'company.name' | transloco}}"
                [(ngModel)]="name_Input" required maxlength="64">
              <mat-error>
                {{'company.errorMandatory' | transloco}}
              </mat-error>
            </mat-form-field>
            <mat-form-field class="full-width">
              <mat-label>{{'company.address1' | transloco}}</mat-label>
              <input matInput type="text" name="address_line_1" placeholder="{{'company.address1' | transloco}}" [(ngModel)]="address_line_1_Input" required maxlength="64">
              <mat-error>
                {{'company.errorMandatory' | transloco}}
              </mat-error>
            </mat-form-field>
            <mat-form-field class="full-width">
              <mat-label>{{'company.address2' | transloco}}</mat-label>
              <input matInput type="text" name="address_line_2" placeholder="{{'company.address2' | transloco}}" [(ngModel)]="address_line_2_Input" maxlength="64">
            </mat-form-field>
            <mat-form-field class="full-width">
              <mat-label>{{'company.companyCity' | transloco}}</mat-label>
              <input matInput type="text" name="city" placeholder="{{'company.city' | transloco}}" [(ngModel)]="city_Input" required maxlength="64">
              <mat-error>
                {{'company.errorMandatory' | transloco}}
              </mat-error>
            </mat-form-field>
            <mat-form-field class="full-width">
              <mat-label>{{'company.country' | transloco}}</mat-label>
              <input matInput type="text" name="country" placeholder="{{'company.country' | transloco}}" [(ngModel)]="country_Input" required maxlength="64">
              <mat-error>
                {{'company.errorMandatory' | transloco}}
              </mat-error>
            </mat-form-field>
            <hr>
            <div style="margin-bottom: 16px; color: #666; font-size: 0.95em;">
              {{'company.generalContactInfoNotice' | transloco}}
            </div>
            <mat-form-field class="full-width">
              <mat-label>{{'company.contactName' | transloco}}</mat-label>
              <input matInput type="text" name="first_contact_person_name" placeholder="{{'company.contactName' | transloco}}" [(ngModel)]="first_contact_person_name_Input" required maxlength="64">
              <mat-error>
                {{'company.errorMandatory' | transloco}}
              </mat-error>
            </mat-form-field>
            <mat-form-field class="full-width">
              <mat-label>{{'company.contactEmail' | transloco}}</mat-label>
              <input matInput type="text" name="first_contact_person_email" placeholder="{{'company.contactEmail' | transloco}}" [(ngModel)]="first_contact_person_email_Input" required email maxlength="64">
              <mat-error>
                {{'company.errorIncorrect' | transloco}}
              </mat-error>
            </mat-form-field>
            <mat-form-field class="full-width">
              <mat-label>{{'company.contactPhone' | transloco}}</mat-label>
              <input matInput type="text" name="first_contact_person_phone" placeholder="{{'company.contactPhone' | transloco}}" [(ngModel)]="first_contact_person_phone_Input" required maxlength="64">
              <mat-error>
                {{'company.errorMandatory' | transloco}}
              </mat-error>
            </mat-form-field>
            <mat-form-field class="full-width">
              <mat-label>{{'company.emergencyName' | transloco}}</mat-label>
              <input matInput type="text" name="emergency_contact_person_name" placeholder="{{'company.emergencyName' | transloco}}" [(ngModel)]="emergency_contact_person_name_Input" required maxlength="64">
              <mat-error>
                {{'company.errorMandatory' | transloco}}
              </mat-error>
            </mat-form-field>
            <mat-form-field class="full-width">
              <mat-label>{{'company.emergencyEmail' | transloco}}</mat-label>
              <input matInput type="text" name="emergency_contact_person_email" placeholder="{{'company.emergencyEmail' | transloco}}" [(ngModel)]="emergency_contact_person_email_Input" required email maxlength="64">
              <mat-error>
                {{'company.errorIncorrect' | transloco}}
              </mat-error>
            </mat-form-field>
          </mat-card-content>

          <div style="margin-top: 20px;">
            <div class="company-actions">
              <button mat-raised-button color="primary" (click)="updateLogo()" type="button">{{'company.add' | transloco}}</button>
              <div class="button-row" fxLayoutAlign="end">
                <button mat-raised-button color="primary" type="submit">{{'company.save' | transloco}}</button>
                <button mat-raised-button color="warn" *ngIf="!new && storageService.roleId==1" type="button" (click)="onEliminarItm()">{{'company.delete' | transloco}}</button>
                <button mat-raised-button color="basic" routerLink="/companies">{{'company.cancel' | transloco}}</button>
              </div>
            </div>
          </div>
        </form>
      </div>

    </div>
  </mat-card>
</div>
